export default __webpack_public_path__ + "static/media/kangoo-colour-1.fb7cfc56.jpg";